import { PureComponent } from "react";

import { StyledReadMoreComponent } from "./read-more-component.scss";

export default class ReadMoreComponent extends PureComponent {
  render() {
    return (
      <StyledReadMoreComponent className="read-more-component">
        Read More >
      </StyledReadMoreComponent>
    );
  }
}
